import { render, staticRenderFns } from "./ProductCommentModal.vue?vue&type=template&id=3e3d3286"
import script from "./ProductCommentModal.vue?vue&type=script&lang=js"
export * from "./ProductCommentModal.vue?vue&type=script&lang=js"
import style0 from "./ProductCommentModal.vue?vue&type=style&index=0&id=3e3d3286&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports